// extracted by mini-css-extract-plugin
module.exports = {"globalHeader":"white__globalHeader--3Fy1f"};
    if(module.hot) {
      // 1545480329094
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  